import axios from 'axios'

// Create axios instance
export const apiClient = axios.create({
  baseURL: '/',
  withCredentials: true, // Important for SSO session cookies
  headers: {
    'Content-Type': 'application/json',
  },
})

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
